import { render, staticRenderFns } from "./ProspectFormCompanyInfo.vue?vue&type=template&id=5024d738&scoped=true&"
import script from "./ProspectFormCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./ProspectFormCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProspectFormCompanyInfo.vue?vue&type=style&index=0&id=5024d738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024d738",
  null
  
)

export default component.exports